import React from "react";
import { CRUDFunction } from "../../../reduxCURD/container";
import { getAllInspectableAssets } from "../../../reduxRelated/actions/assetHelperAction";
import { withRouter } from "react-router-dom";
import OOSAssetList from "./OOSAssetList";
import OOSBlueCardDetail from "./OOSBlueCardDetail";
import { curdActions } from "../../../reduxCURD/actions";

class OOSReview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reportType: "pending",
      reportTypeOptions: [
        { val: "pending", text: "Pending" },
        { val: "certified", text: "Certified" },
      ],
      spinnerLoading: false,
      assets: [],
      viewMode: "list", // "list" or "detail"
      asset: {
        assetId: null,
        year: null,
      },
      selectedYear: new Date().getFullYear(),
    };
    this.onReportTypeChange = this.onReportTypeChange.bind(this);
    this.onViewAsset = this.onViewAsset.bind(this);
    this.onBack = this.onBack.bind(this);
  }

  componentDidMount() {
    this.fetchAssets(this.state.reportType, this.state.selectedYear);
  }

  componentDidUpdate(prevProps, prevState) {
    // if (
    //   prevState.reportType !== this.state.reportType ||
    //   prevState.viewMode !== this.state.viewMode ||
    //   (this.state.reportType === "certified" && prevState.selectedYear !== this.state.selectedYear)
    // ) {
    //   this.setState({ spinnerLoading: true });
    //   this.fetchAssets();
    // }
    if (this.props.actionType === "OUTOFUSEBLUECARDS_READ_REQUEST" && this.props.actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: true });
    }
    if (this.props.actionType === "OUTOFUSEBLUECARDS_READ_SUCCESS" && this.props.actionType !== prevProps.actionType) {
      this.setState({
        spinnerLoading: false,
        assets: this.props.OutOfUseBlueCards,
      });
    }
    if (this.props.actionType === "OUTOFUSEBLUECARDS_READ_FAILURE" && this.props.actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: false });
    }
  }

  onReportTypeChange(e) {
    const newType = e.target.value;
    this.setState({ reportType: newType });
    this.fetchAssets(newType, this.state.selectedYear);
  }

  onYearChange = (e) => {
    const year = parseInt(e.target.value, 10);
    this.setState({ selectedYear: year });
    this.fetchAssets(this.state.reportType, year);
  };

  onViewAsset(asset) {
    const year = this.state.selectedYear;
    const assetId = asset._id.toString();
    this.setState({
      viewMode: "detail",
      asset: {
        assetId: assetId,
        year: year,
      },
    });
  }

  onBack() {
    this.setState({
      viewMode: "list",
      asset: { assetId: null, year: null },
      spinnerLoading: true,
    });

    this.fetchAssets(this.state.reportType, this.state.selectedYear);
  }

  fetchAssets = (reportType, selectedYear) => {
    let url = `getOOUlookupAssets?type=${reportType}`;
    if (reportType === "certified") {
      url += `&year=${selectedYear}`;
    }
    this.props.getOutOfUseBlueCards(url);
  };

  render() {
    const { reportType, reportTypeOptions, spinnerLoading, assets, viewMode, asset } = this.state;
    const visibleAssets = reportType === "pending" ? assets.pendingAssets : assets.certifiedAssets;

    if (viewMode === "list") {
      return (
        <OOSAssetList
          {...this.props}
          reportType={reportType}
          reportTypeOptions={reportTypeOptions}
          onReportTypeChange={this.onReportTypeChange}
          assets={visibleAssets}
          onViewAsset={this.onViewAsset}
          selectedYear={this.state.selectedYear}
          onYearChange={this.onYearChange}
          spinnerLoading={spinnerLoading}
        />
      );
    } else if (viewMode === "detail") {
      return (
        <OOSBlueCardDetail {...this.props} spinnerLoading={spinnerLoading} asset={asset} onBack={this.onBack} reportType={reportType} />
      );
    }
    return null;
  }
}
let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
};

const OOSReviewContainer = CRUDFunction(OOSReview, "OutOfUseBlueCard", actionOptions, null, [], "testSchedule");

export default withRouter(OOSReviewContainer);



// WEBPACK FOOTER //
// ./src/components/ReviewsCertifications/OOS/OOSReview.jsx